import React, { FC, useCallback } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext } from 'react-hook-form';

import InputField from 'buyside/components/presentation/Fields/inputField';
import MultiSelectField from 'buyside/components/presentation/Fields/multiSelectField';
import ResearchFormWizardSection from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';

import styles from './titleAndCategoriesStyles.scss';

const {
  esgs,
  geographies,
  globalMacros,
  sectors
} = require('buyside/util/constantsFromRails.json');

const formatCategoryOptions = (
  categories: {
    id: number;
    name: string;
  }[]
): { label: string; value: string }[] =>
  categories.map(({ id, name }) => ({
    label: name,
    value: String(id)
  }));

const TitleAndCategories: FC = () => {
  const {
    formState: { errors },
    trigger
  } = useFormContext();

  const validateTotalCategories = useCallback(() => trigger('totalCategories'), [trigger]);

  return (
    <>
      <ResearchFormWizardSection title="Report Title">
        <div className={styles.titleContainer}>
          <InputField name="title" type="textarea" />
        </div>
      </ResearchFormWizardSection>
      <ResearchFormWizardSection title="Categories">
        <div className={styles.categoriesContainer}>
          <MultiSelectField
            name="sectors"
            label="sectors"
            options={formatCategoryOptions(sectors)}
            onChangeCallback={validateTotalCategories}
          />
          <MultiSelectField
            name="esgs"
            label="esgs"
            options={formatCategoryOptions(esgs)}
            onChangeCallback={validateTotalCategories}
          />
          <MultiSelectField
            name="geographies"
            label="geographies"
            options={formatCategoryOptions(geographies)}
            onChangeCallback={validateTotalCategories}
          />
          <MultiSelectField
            name="globalMacros"
            label="global macros"
            options={formatCategoryOptions(globalMacros)}
            onChangeCallback={validateTotalCategories}
          />
        </div>
        {errors.totalCategories ? (
          <label className={styles.errorMessage}>
            <FontAwesomeIcon icon={faExclamationCircle} />
            {errors.totalCategories.message as string}
          </label>
        ) : null}
      </ResearchFormWizardSection>
    </>
  );
};

export default TitleAndCategories;
